import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/info.png'


const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_5 = { class: "flex card-toolbar w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "p-input-icon-left w-10/12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "card-toolbar w-full" }
const _hoisted_10 = { class: "flex flex-col justify-center" }
const _hoisted_11 = {
  key: 0,
  class: ""
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "inline-block w-4 align-text-bottom",
  src: _imports_0,
  alt: "Your avatar"
}, null, -1)
const _hoisted_13 = {
  key: 1,
  class: ""
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "inline-block w-4 align-text-bottom",
  src: _imports_0,
  alt: "Your avatar"
}, null, -1)
const _hoisted_15 = { class: "card-toolbar w-full" }
const _hoisted_16 = { class: "flex justify-end" }
const _hoisted_17 = { class: "card-body pt-0" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "d-flex flex-row whitespace-nowrap" }

import DataTable from "primevue/datatable";
import {ref, onMounted, computed} from 'vue';
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Column from "primevue/column";
import router from "@/router";
import swal from "@/_helpers/swal";
import {IMiddleMenuItem} from "@/models/homepage/IMiddleMenuItem";
import {deleteMiddleMenuItem, fetchAll} from "@/_services/homepage/middleMenuItem";
import { useRoute, useRouter } from 'vue-router'
import {fetchByUuid} from "@/_services/homepage/middleMenu";
import {IMiddleMenu} from "@/models/homepage/IMiddleMenu";

export default /*#__PURE__*/_defineComponent({
  __name: 'MiddleMenuItemList',
  setup(__props) {

const middleMenuItem = Array<IMiddleMenuItem>();
const middleMenu = Array<IMiddleMenu>();
const tableData = ref<Array<IMiddleMenuItem>>(middleMenuItem);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const route = useRoute();
const routerUse = useRouter();
const uuidRouteParam = ref<string>("");
const titleMiddleMenu = ref<string>("");

const allowedTypes = ['region', 'travel']

const type = computed(() => {
    const current = route.params.type as string | undefined
    return allowedTypes.includes(current ?? '') ? current : null
})

if (route.params.type && !allowedTypes.includes(route.params.type as string)) {
    router.replace({ name: 'middleMenuItemList' })
}

onMounted(async () => {
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    await hydrateTitleMiddleMenu(uuidRouteParam.value);
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});


const hydrateTitleMiddleMenu = async (uuid) => {
    const middleMenu = await fetchByUuid(uuid);
    titleMiddleMenu.value = middleMenu.title;
}

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchAll(
        uuidRouteParam.value,
        itemsPerPage,
        page,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
    isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const onSearchInputDt = () => {
    if (0 === criteria.value.length || 3 <= criteria.value.length) {
        populateDatatable(
            rows.value,
            page.value,
            "" != criteria.value ? criteria.value : ""
        );
    }
}

const onDelete = (data: IMiddleMenuItem) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer ?")
        .then((result) => {
            if (result.isConfirmed) {
                deleteMiddleMenuItem(data.uuid).then((result) => {
                    if (result) {
                        swal.success("succés !", "Suppression effectuée avec succès");
                    }
                    populateDatatable(
                        rows.value,
                        page.value,
                        "" != criteria.value ? criteria.value : ""
                    );
                });
            }
        });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, "Gérer la liste des références : " + _toDisplayString(titleMiddleMenu.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        removableSort: "",
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 100],
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: _cache[4] || (_cache[4] = ($event: any) => (onPaginate($event))),
        onSort: _cache[5] || (_cache[5] = ($event: any) => (onSort($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "w-9/12",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                    placeholder: "Rechercher...",
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onSearchInputDt()), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, "Nombre total : " + _toDisplayString(totalRecords.value), 1)
              ]),
              (type.value && type.value == 'travel')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" Les 6 premiers produits sont visibles sur la page d'accueil ")
                  ]))
                : _createCommentVNode("", true),
              (type.value && type.value == 'region')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" Les 8 premiers produits sont visibles sur la page d'accueil ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Button), {
                  size: "small",
                  class: "btn btn-primary p-2 ps-2 pe-2",
                  style: {"margin-right":"0.5em"},
                  title: "Ajouter",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'addMiddleMenuItem', params: { uuid: uuidRouteParam.value, blockType: type.value} })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ajouter ")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  size: "small",
                  class: "btn btn-primary p-2 ps-2 pe-2",
                  style: {"margin-right":"0.5em"},
                  title: "Ajouter",
                  onClick: _cache[3] || (_cache[3] = () => {
                                      if (type.value === 'region') {
                                        _unref(router).push({ name: 'regionList'})
                                      } else if (type.value === 'travel') {
                                        _unref(router).push({ name: 'travelList' })
                                      } else {
                                        _unref(router).push({ name: 'middleMenuList' })
                                      }
                                    })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Retour ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun produit ne correspond à votre recherche")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(Column), {
              field: "vignette",
              header: "Miniature"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.imageWeb)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.data.imageWeb.url,
                      class: "w-14"
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "title",
              header: "Titre",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "position",
              header: "position",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.position), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "action",
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-pencil",
                    class: "p-edition",
                    style: {"margin-right":"0.5em"},
                    title: "Éditer",
                    onClick: ($event: any) => (_unref(router).push({ name: 'editMiddleMenuItem', params: { uuid: slotProps.data.uuid, blockType: type.value } }))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    style: {"margin-right":"0.5em"},
                    title: "supprimer",
                    onClick: ($event: any) => (onDelete(slotProps.data))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})